import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { z } from 'zod';

const DataImportUploadPage = lazy(() =>
  import('@/features/data-import/upload/DataImportUploadPage').then((m) => ({
    default: m.DataImportUploadPage,
  })),
);

export const Route = createFileRoute('/app/data-import/add')({
  validateSearch: z.object({ returnTo: z.string().optional() }),
  component: () => {
    const { returnTo } = Route.useSearch();
    return (
      <Suspense>
        <DataImportUploadPage returnTo={returnTo} />
      </Suspense>
    );
  },
});
